import { type PropsWithChildren, useRef } from 'react';

import { createStore, Store } from '../../../core/store/store.js';
import { initialState } from '../constants/defaults.js';
import { XYChartStoreContext } from '../context/XYChartStore.context.js';
import type { XYChartState } from '../types/state.js';

export const XYChartStoreProvider = ({ children }: PropsWithChildren) => {
  const storeRef = useRef<Store<XYChartState>>(undefined);

  const lastInteraction = storeRef?.current?.getState().interactionMode;

  storeRef.current = createStore<XYChartState>({
    ...initialState,
    interactionMode: lastInteraction || 'explore',
  });

  return (
    <XYChartStoreContext.Provider value={storeRef.current}>
      {children}
    </XYChartStoreContext.Provider>
  );
};
